/* eslint-disable @next/next/no-img-element */
'use client'

import { createThumbnailHoverHandlers } from '@/components/video/HoverAnimatedThumbnail'
import UnifiedPlayMark from '@/components/embedding/UnifiedPlayMark'
import { FC } from 'react'

export interface SliderThumbnailCardProps {
  thumbnailUrl?: string | null
  animatedThumbnailUrl?: string | null
  alt: string
  onClick: () => void
}

const SliderThumbnailCard: FC<SliderThumbnailCardProps> = ({ thumbnailUrl, animatedThumbnailUrl, alt, onClick }) => {
  return (
    <div
      className="thumbnail-card group cursor-pointer rounded-2xl overflow-hidden bg-gray-100 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_10px_25px_rgba(0,0,0,0.2)]"
      onClick={onClick}
    >
      <div className="relative w-full overflow-hidden bg-black rounded-2xl" style={{ paddingBottom: '100%' }}>
        {thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt={alt}
            className="absolute top-0 left-0 w-full h-full object-cover"
            {...createThumbnailHoverHandlers(thumbnailUrl, animatedThumbnailUrl)}
          />
        ) : (
          <div className="absolute top-0 left-0 w-full h-full bg-gray-500" />
        )}
        <div className="play-overlay pointer-events-none absolute top-0 left-0 w-full h-full flex items-center justify-center opacity-0 transition-all duration-200">
          <UnifiedPlayMark />
        </div>
      </div>
    </div>
  )
}

export default SliderThumbnailCard
